import { useRef } from 'react';
import { KebabIcon } from '../Icons';
import CompanyInfo from '../core/CompanyInfo';
import { getContrastColor } from '../../utils/utils';

const VirtualBoothDemo = ({
  title,
  subtitle,
  logo,
  background,
  buttonUrl,
  accentColor,
  companyInfo,
  isSimple = false,
}) => {
  const accentTextColor = useRef(getContrastColor(accentColor));

  const actualSubtitle = subtitle || 'Celebrate with us by capturing a memory digitally!';

  const getBackgroundEl = () => {
    if (!background) {
      return null;
    }
    return ['mp4', 'm4v'].includes(background.split('.').pop()) ? (
      <video className="vb-demo__background" src={`${background}#t=0.1`} autoPlay loop muted playsInline />
    ) : (
      <img className="vb-demo__background" alt="" src={background} />
    );
  };
  const backgroundEl = getBackgroundEl();

  const vbDemo = (type) => (
    <div className={`vb-demo vb-demo--${type}`}>
      {backgroundEl}
      <div className="vb-demo__header">
        {logo && <img className="vb-demo__logo" alt="" src={logo} />}
        <h3 className="vb-demo__title">{title}</h3>
        <p className="vb-demo__subtitle">{actualSubtitle}</p>
        <KebabIcon />
      </div>
      <div className="vb-demo__titlebar">
        <h3 className="vb-demo__title">{title}</h3>
        <p className="vb-demo__subtitle">{actualSubtitle}</p>
      </div>
      <div className="vb-demo__body">
        {buttonUrl ? (
          <img className="vb-demo__btn vb-demo__btn--img" alt="" src={buttonUrl} />
        ) : (
          <div className="vb-demo__btn" style={{ backgroundColor: accentColor, color: accentTextColor.current }}>
            Start virtual booth
          </div>
        )}
      </div>
      {companyInfo && (
        <div className="vb-demo__footer">
          <CompanyInfo company={companyInfo} accentColor={accentColor} contrastColor={accentTextColor.current} />
        </div>
      )}
    </div>
  );

  return (
    <div className="responsive-demo">
      <div className="macbook-demo">
        <div className="macbook-demo__phone">
          <div className="macbook-demo__screen">{vbDemo('desktop')}</div>
        </div>
      </div>
      {!isSimple && (
        <div className="iphone-demo">
          <div className="iphone-demo__phone">
            <div className="iphone-demo__screen">{vbDemo('mobile')}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VirtualBoothDemo;
